export default __webpack_public_path__ + "static/img/aw-2020.13c5ec6.jpg";